import { Injectable, inject } from '@angular/core';

import { UserAgentService } from './user-agent.service';

export interface CallbackMessageEvent extends MessageEvent {
  data: CallbackMessageEventData;
}

export interface CallbackMessageEventData {
  id: string;
  params: unknown[];
}

@Injectable({
  providedIn: 'root',
})
export class CallbackService {
  private readonly agent = inject(UserAgentService);

  url: string | undefined;

  list = {
    tokenExpired: 'tokenExpired',
    logout: 'logout',
    setTitle: 'setTitle',
    changeCurrentTitle: 'changeCurrentTitle',
    didUpdateUserData: 'didUpdateUserData',
    shouldGoBack: 'shouldGoBack',
    enableBack: 'enableBack',
    enableClose: 'enableClose',
    forceBack: 'forceBack',
    endLoading: 'endLoading',
    startLoading: 'startLoading',
    quizzDone: 'quizzDone',
    quizzStart: 'quizzStart',
    quizzCloseSchedule: 'quizzCloseSchedule',
    needsWifiChange: 'needsWifiChange',
    needsHomekitInstall: 'needsHomekitInstall',
    needsHomekitConfigure: 'needsHomekitConfigure',
    needsNewModule: 'needsNewModule',
    needsNewInstall: 'needsNewInstall',
    shouldExit: 'shouldExit',
    didUpdateUserDataAndExit: 'didUpdateUserDataAndExit',
    shareIt: 'shareIt',
    canShare: 'canShare',
    openInBrowser: 'openInBrowser',
    download: 'download',
    updateFirmware: 'updateFirmware',
    onPageLoaded: 'onPageLoaded',
    disassociateMyStation: 'disassociateMyStation',
    disassociateOtherStation: 'disassociateOtherStation',
    configureWifi: 'configureWifi',
    calibrationSuccess: 'calibrationSuccess',
    calibrationFailure: 'calibrationFailure',
    shouldRemoveUser: 'shouldRemoveUser',
    onNacAlertAway: 'onNacAlertAway',
    onNacAlertHome: 'onNacAlertHome',
    onNteAlertAway: 'onNteAlertAway',
  };

  setUrl(url: string): void {
    this.url = url;
  }

  call = (name: string, args: any | null = null): void => {
    if (this.agent.isNativeApp()) {
      let iframe: HTMLElement | null = document.createElement('IFRAME');
      iframe.setAttribute('src', `js-frame:${name}:0:${encodeURIComponent(JSON.stringify(args))}`);
      document.documentElement.appendChild(iframe);
      iframe.parentNode?.removeChild(iframe);
      iframe = null;
    } else {
      const msg: CallbackMessageEventData = { id: name, params: args };
      window.parent.postMessage(msg, '*');
    }
  };
}
